/**
 * PWA Service Worker registration.
 * Registers the combined FCM + offline caching service worker.
 */
export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", async () => {
      try {
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );
        console.log("SW registered, scope:", registration.scope);

        // Check for updates periodically (every 60 min)
        setInterval(() => registration.update(), 60 * 60 * 1000);
      } catch (err) {
        console.error("SW registration failed:", err);
      }
    });
  }
}
